var render = function render(){var _vm=this,_c=_vm._self._c;return _c('category',{attrs:{"name":"Parkour","categorystyle":"parkour_category"}},[_c('block',{attrs:{"type":"parkour_checkpoint"}}),_c('block',{attrs:{"type":"fail_parkour"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }